<template>
  <div>
    <!-- Child component content -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    async fetchData(url) {
      try {
        const response = await axios.get(url, {
          headers: {
            accept: "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0OTA1NGYzMmYwNzBkM2U5Y2E5ZDY0MGRiZDk4ZTgxMiIsInN1YiI6IjY0ODgxYTUyZTI3MjYwMDE0N2JiNWRmMyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.aTCJSMUpFpF646dLzsurljwCm-Zy9EaG74hEcq1ka34",
          },
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    },
  },
};
</script>
